/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AggregierteAuswertungLayoutDto } from '../../models/aggregierte-auswertung-layout-dto';
import { CreateAggregierteAuswertungLayoutDto } from '../../models/create-aggregierte-auswertung-layout-dto';

export interface UpdateAggregierteAuswertungLayout$Plain$Params {
  id: string;
      body?: CreateAggregierteAuswertungLayoutDto
}

export function updateAggregierteAuswertungLayout$Plain(http: HttpClient, rootUrl: string, params: UpdateAggregierteAuswertungLayout$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AggregierteAuswertungLayoutDto>> {
  const rb = new RequestBuilder(rootUrl, updateAggregierteAuswertungLayout$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AggregierteAuswertungLayoutDto>;
    })
  );
}

updateAggregierteAuswertungLayout$Plain.PATH = '/v1/aggregierteAuswertung/layouts/{id}';
